import { createSlice } from "@reduxjs/toolkit";
import {
  CURRENT_DAY_TOUR_ASM_DATA_SUCCESS,
  CURRENT_DAY_TOUR_ASM_DATA_FAIL,
  GET_HO_SH7_Code_SUCCESS,
  GET_HO_SH7_Code_FAIL,
  GET_HO_Nsm_Email_SUCCESS,
  GET_HO_Nsm_Email_FAIL,
  GET_MVR_DRAFT_SUCCESS,
  REMOVE_MVR_DRAFT_SUCCESS,
  GET_SALESGRUOP_USER_SUCCESS,
  GET_SALESGRUOP_USER_FAIL,
  GET_MY_USER_FEEDBACK_SUCCESS,
  GET_MY_USER_FEEDBACK_FAIL,
} from "../constants/action-types";

// --- Current Day Tour Slice ---
const currentDayTourSlice = createSlice({
  name: "currentDayTour",
  initialState: { currentDayTourList: [], loading: true },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CURRENT_DAY_TOUR_ASM_DATA_SUCCESS, (state, { payload }) => {
        state.currentDayTourList = payload;
        state.loading = false;
      })
      .addCase(CURRENT_DAY_TOUR_ASM_DATA_FAIL, (state) => {
        state.currentDayTourList = [];
        state.loading = false;
      });
  },
});

// --- HO User SH7 Code Slice ---
const hoUserSlice = createSlice({
  name: "hoUserSh7Code",
  initialState: { sh7Code: "", nsmEmail: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_HO_SH7_Code_SUCCESS, (state, { payload }) => {
        state.sh7Code = payload;
      })
      .addCase(GET_HO_SH7_Code_FAIL, (state) => {
        state.sh7Code = "";
      })
      .addCase(GET_HO_Nsm_Email_SUCCESS, (state, { payload }) => {
        state.nsmEmail = payload;
      })
      .addCase(GET_HO_Nsm_Email_FAIL, (state) => {
        state.nsmEmail = "";
      });
  },
});

// --- MVR Draft Slice ---
const mvrDraftSlice = createSlice({
  name: "mvrDraft",
  initialState: { draft: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_MVR_DRAFT_SUCCESS, (state, { payload }) => {
        state.draft = payload;
      })
      .addCase(REMOVE_MVR_DRAFT_SUCCESS, (state, { payload }) => {
        state.draft = payload;
      });
  },
});

// --- Sales Group User Slice ---
const salesgroupUserSlice = createSlice({
  name: "salesgroupUser",
  initialState: { salesgroupUserList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_SALESGRUOP_USER_SUCCESS, (state, { payload }) => {
        state.salesgroupUserList = payload;
      })
      .addCase(GET_SALESGRUOP_USER_FAIL, (state) => {
        state.salesgroupUserList = [];
      });
  },
});

// --- My User Feedback Slice ---
const myUserFeedbackSlice = createSlice({
  name: "myUserFeedback",
  initialState: { userList: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_MY_USER_FEEDBACK_SUCCESS, (state, { payload }) => {
        state.userList = payload;
      })
      .addCase(GET_MY_USER_FEEDBACK_FAIL, (state) => {
        state.userList = [];
      });
  },
});

export const currentDayTourReducer = currentDayTourSlice.reducer;
export const HoUserSh7CodeReducer = hoUserSlice.reducer;
export const mvrDraftReducer = mvrDraftSlice.reducer;
export const salesgroupUserReducer = salesgroupUserSlice.reducer;
export const myUserFeedbackReducer = myUserFeedbackSlice.reducer;
